import { useRef, useEffect } from 'react'
import clsx from 'clsx'
import ParticipantInfo from '../ParticipantInfo'
import AudioIndicator from '../AudioIndicator'

export default function VideoCard({
  videoTrack,
  audioTrack,
  participant,
  isMuted = false,
  isSpeaking = false,
  placeholder,
  className,
}) {
  const videoRef = useRef(null)
  const audioRef = useRef(null)

  useEffect(() => {
    if (videoRef.current && videoTrack) {
      // Attach Twilio video track to video element
      const videoElement = videoRef.current
      videoTrack.attach(videoElement)
      
      return () => {
        videoTrack.detach(videoElement)
      }
    }
  }, [videoTrack])

  useEffect(() => {
    if (audioRef.current && audioTrack) {
      // Attach Twilio audio track to audio element
      const audioElement = audioRef.current
      audioTrack.attach(audioElement)
      
      return () => {
        audioTrack.detach(audioElement)
      }
    }
  }, [audioTrack])

  const showPlaceholder = !videoTrack || placeholder

  return (
    <div
      className={clsx(
        'video-card',
        isSpeaking && 'speaking',
        className
      )}
    >
      {!showPlaceholder && (
        <>
          <video
            ref={videoRef}
            autoPlay
            playsInline
            muted={isMuted}
            className="w-full h-full object-cover block bg-black"
          />
          {audioTrack && (
            <audio
              ref={audioRef}
              autoPlay
              playsInline
              muted={isMuted}
            />
          )}
        </>
      )}

      {participant && (
        <div className="video-overlay">
          <ParticipantInfo
            name={participant.name}
            role={participant.role}
            avatar={participant.avatar}
          />
          <AudioIndicator isMuted={isMuted} isActive={isSpeaking} />
        </div>
      )}

      {showPlaceholder && (
        <div className="video-placeholder">
          <div className="placeholder-icon">
            {placeholder?.icon || '📹'}
          </div>
          <div className="placeholder-text">
            {placeholder?.text || 'Waiting for video...'}
          </div>
        </div>
      )}
    </div>
  )
}
